module.exports = __webpack_public_path__ + "img/bottom_about_4.3e489df4.png";